import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './sw/registerServiceWorker';
import 'material-design-icons/iconfont/material-icons.css';
import 'typeface-roboto/index.css';

ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();

// window.addEventListener('load', function () {
//     window.history.pushState({}, '')
// })

// window.addEventListener('popstate', function () {
//     window.history.pushState({}, '')
// })


